import { Trans, useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { TwoFactorChangeAuthQRCode } from "@/components/Portal/UserAccount/Security/Change/TwoFactorChangeAuthQRCode";
import { useManualSetupDefault } from "@/hooks/useManualSetupDefault";
import { SetUpTwoFactorAuthenticationReponse } from "@/services/model";

import {
  stepDescriptionClassName,
  stepHeadingClassName,
} from "./authenticator.utils";
import { FAQLink } from "./FAQLink";
import { ManualKeyField } from "./ManualKeyField";
import { TwoFactorConfirmationInput } from "./TwoFactorConfirmationInput";

export const AuthenticatorAppForm = ({
  authSetupData,
}: {
  authSetupData?: SetUpTwoFactorAuthenticationReponse;
}) => {
  const { t } = useTranslation();
  const [showManualSetup, setShowManualSetup] = useManualSetupDefault();

  return (
    <>
      <div className="flex flex-col gap-4">
        <h2 className={stepHeadingClassName}>
          {t("portal:authenticator.app.setup.step1.title")}
        </h2>
        <p className={stepDescriptionClassName}>
          <Trans
            i18nKey="portal:authenticator.app.setup.step1.description"
            components={{ FAQ: <FAQLink /> }}
          />
        </p>
        <div className="flex flex-col items-center gap-2">
          {showManualSetup ? (
            <ManualKeyField manualCode={authSetupData?.manualCode} />
          ) : (
            <div className="flex w-full justify-center rounded-md bg-surface-tertiary p-4">
              <TwoFactorChangeAuthQRCode
                qrCodeData={authSetupData?.qrCodeUri}
              />
            </div>
          )}
          <Button
            variant="tertiary"
            size="sm"
            type="button"
            onClick={() => setShowManualSetup((prev) => !prev)}
          >
            {t(
              showManualSetup
                ? "portal:authenticator.app.setup.step1.show-qr-code"
                : "portal:authenticator.app.setup.step1.enter-key-manually",
            )}
          </Button>
        </div>
      </div>
      <div className="flex flex-col gap-4">
        <h2 className={stepHeadingClassName}>
          {t("portal:authenticator.app.setup.step2.title")}
        </h2>
        <p className={stepDescriptionClassName}>
          {t("portal:authenticator.app.setup.step2.description")}
        </p>
        <TwoFactorConfirmationInput />
      </div>
    </>
  );
};
